import { render, staticRenderFns } from "./AboutImageComposition.vue?vue&type=template&id=c01989be&scoped=true"
import script from "./AboutImageComposition.vue?vue&type=script&lang=js"
export * from "./AboutImageComposition.vue?vue&type=script&lang=js"
import style0 from "./AboutImageComposition.vue?vue&type=style&index=0&id=c01989be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01989be",
  null
  
)

export default component.exports